export default [
    {
        name: 'motorSceneTexture',
        type: 'texture',
        path: 'textures/mainBaked.jpg'
    },
    {
        name: 'motorSceneModel',
        type: 'gltfModel',
        path: 'models/DCMotor.glb'
    },
    {
        name: 'forceLabelTexture',
        type: 'texture',
        path: 'textures/forceVect.png'
    },
    {
        name: 'fieldLabelTexture',
        type: 'texture',
        path: 'textures/fieldVect.png'
    },
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
            [
                'textures/px.png',
                'textures/nx.png',
                'textures/py.png',
                'textures/ny.png',
                'textures/pz.png',
                'textures/nz.png'
            ]
    },
    {
        name: 'widthLabelTexture',
        type: 'texture',
        path: 'textures/a.png'
    },
    {
        name: 'lengthLabelTexture',
        type: 'texture',
        path: 'textures/L.png'
    },
    {
        name: 'halfWidthLabelTexture',
        type: 'texture',
        path: 'textures/ahalf.png'
    },
    {
        name: 'momentArmLabelTexture',
        type: 'texture',
        path: 'textures/ahalfCos.png'
    },
    {
        name: 'thetaLabelTexture',
        type: 'texture',
        path: 'textures/theta.png'
    },
    {
        name: 'currentLabelTexture',
        type: 'texture',
        path: 'textures/I.png'
    },
]